function ClearButton({ onClicked }) {
  return (
    <div
      onClick={onClicked}
      className="rounded-[4px] flex items-center px-[10px] w-[98px] h-[30px] cursor-pointer justify-center border-borderColor border-[1px] bg-white border-[1px]"
    >
      <span className="font-OpenSansRegular text-[12px] font-[600] text-titleColor">Clear</span>
    </div>
  );
}

export default ClearButton;
